import ApiService from "@/service/ApiService";

export default function useRegister() {
  const Register = async (data) => {
    return await ApiService.post("register_student", data);
  };

  const GetCommunitys = async () => {
    return await ApiService.get("get_communitys");
  };

  const UpdateUser = async (data) => {
    return await ApiService.put("edit_user/" + data.id_line, data);
  };

  const History = async () => {
    return await ApiService.get("register_student_history");
  };

  return {
    Register,
    UpdateUser,
    GetCommunitys,
    History
  };
}
